import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
import {
  AccessCardEntry,
  CardStatus,
  FilterAssignedState,
  FilterStatusState,
  FilterValidity,
  FilterValidityState
} from './cardFilterTypes';

dayjs.extend(isBetween);

const validityDaysMap: Record<NonNullable<FilterValidityState>, number> = {
  [FilterValidity.OneDay]: 1,
  [FilterValidity.ThreeDays]: 3,
  [FilterValidity.OneWeek]: 7,
  [FilterValidity.OneMonth]: 30
};

// cardExpiresSoon has no checkbox here — it's covered by the "validity" radio filter below instead
const isFilterableStatus = (status: CardStatus): status is keyof FilterStatusState => status !== 'cardExpiresSoon';

const isExpiringWithin = (entry: AccessCardEntry, days: number): boolean =>
  Boolean(
    entry.expiryDate &&
      !entry.expired &&
      dayjs(entry.expiryDate).isBetween(dayjs(), dayjs().add(days, 'days'), 'day', '[]')
  );

type Params = {
  entries: AccessCardEntry[];
  filterStatus: FilterStatusState;
  filterValidity: FilterValidityState;
  filterAssigned: FilterAssignedState;
  hideBlocked: boolean;
};

export const filterCards = ({
  entries,
  filterStatus,
  filterValidity,
  filterAssigned,
  hideBlocked
}: Params): AccessCardEntry[] => {
  let data = entries;

  if (hideBlocked) data = data.filter((entry) => !entry.blocked);

  if (Object.values(filterStatus).some(Boolean))
    data = data.filter((entry) => entry.statuses.some((status) => isFilterableStatus(status) && filterStatus[status]));

  if (filterValidity !== null) {
    const days = validityDaysMap[filterValidity];
    data = data.filter((entry) => isExpiringWithin(entry, days));
  }

  if (filterAssigned === FilterAssignedState.Unassigned) data = data.filter((entry) => !entry.assigned);
  else if (filterAssigned === FilterAssignedState.Assigned) data = data.filter((entry) => entry.assigned);

  return data;
};
